import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import { AuthProvider } from "./auth/AuthProvider.tsx";
import { DatabaseProvider } from "./database/DatabaseProvider.tsx";
import { ControlProvider } from "./control/ControlProvider.tsx";
import { DataProvider } from "./data/DataProvider.tsx";
import { DwhDataProvider } from "./data/DwhDataProvider.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <DatabaseProvider>
          <ControlProvider>
            <DataProvider>
              <DwhDataProvider>
                <App />
              </DwhDataProvider>
            </DataProvider>
          </ControlProvider>
        </DatabaseProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
